<div class="home-wrapper">

  <!-- Header Minimalista y Personalizado -->
  <header class="home-header">
    <div class="header-left">
      <div class="kicker">
        <span class="status-dot"></span>
        <span>{{ userRole || 'Panel General' }}</span>
      </div>
      <h1 class="home-title">
        Bienvenido<span *ngIf="userName">, {{ userName }}</span>
      </h1>
      <p class="home-subtitle">
        Acceso centralizado a los módulos asignados a tu cuenta.
      </p>
    </div>

    <!-- Buscador Rápido de Módulos (se muestra si tiene más de 4 rutas) -->
    <div class="header-search" *ngIf="!isLoading && totalRoutesCount > 4">
      <div class="search-input-wrapper">
        <i class="fas fa-search search-icon"></i>
        <input 
          type="text" 
          [value]="searchQuery" 
          (input)="onSearchInput($event)"
          placeholder="Buscar módulo o ruta..." 
          class="search-input"
        />
        <button *ngIf="searchQuery" (click)="clearSearch()" class="clear-search-btn" type="button" title="Limpiar búsqueda">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </header>

  <!-- Estado de Carga (Skeleton Shimmer) -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="skeleton-category" *ngFor="let i of [1, 2, 3]">
      <div class="skeleton-header">
        <div class="skeleton-pill"></div>
        <div class="skeleton-line"></div>
      </div>
      <div class="skeleton-grid">
        <div class="skeleton-card" *ngFor="let j of [1, 2, 3, 4]"></div>
      </div>
    </div>
  </div>

  <!-- Contenido Dinámico: Categorías y Rutas Asignadas -->
  <div class="categories-wrapper" *ngIf="!isLoading && filteredCategories.length > 0">
    <section class="category-section" *ngFor="let category of filteredCategories">

      <!-- Category Header -->
      <div class="category-header">
        <div class="category-title-group">
          <span class="category-icon" [style.color]="category.accentColor">
            <i class="fas" [ngClass]="category.icon"></i>
          </span>
          <h2 class="category-title">{{ category.name }}</h2>
          <span class="category-count">{{ category.cards.length }}</span>
        </div>
        <div class="category-line"></div>
      </div>

      <!-- Cards Grid -->
      <div class="cards-grid">
        <div
          class="route-card"
          *ngFor="let card of category.cards"
          (click)="navigate(card.route)"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Ir a ' + card.title"
          (keydown.enter)="navigate(card.route)"
        >
          <div class="card-icon-wrapper" [style.color]="card.accentColor">
            <i class="fas" [ngClass]="card.icon"></i>
          </div>
          <div class="card-info">
            <h3 class="card-title">{{ card.title }}</h3>
            <p class="card-description">{{ card.description }}</p>
          </div>
          <div class="card-arrow" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </div>
        </div>
      </div>

    </section>
  </div>

  <!-- Estado Vacío por Búsqueda -->
  <div class="empty-state" *ngIf="!isLoading && filteredCategories.length === 0 && searchQuery">
    <div class="empty-icon-wrapper">
      <i class="fas fa-search"></i>
    </div>
    <h3 class="empty-title">Sin resultados para "{{ searchQuery }}"</h3>
    <p class="empty-desc">No se encontraron rutas asignadas que coincidan con tu búsqueda.</p>
    <button type="button" class="btn-clear-search" (click)="clearSearch()">Mostrar todas</button>
  </div>

  <!-- Estado Sin Rutas Asignadas -->
  <div class="empty-state" *ngIf="!isLoading && allCategories.length === 0 && !searchQuery">
    <div class="empty-icon-wrapper">
      <i class="fas fa-shield-halved"></i>
    </div>
    <h3 class="empty-title">Sin módulos asignados</h3>
    <p class="empty-desc">Tu usuario no tiene módulos asignados en este momento. Por favor contacta al administrador del sistema.</p>
  </div>

</div>